<template>
    <div class="container-fluid form-container fire-alarm-test-form-container">
        <div class="row">
            <div class="col-sm-12">
                <h1 class="page-title">
                    Fire Alarm Test Form (Old)
                </h1>
            </div>
        </div>
        <form
            action=""
            class="fire-alarm-test-form"
            @submit.prevent="saveForm()"
        >
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Customer Details</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 form-group">
                            <label for="panel_name">Panel Name:</label>
                            <input
                                type="text"
                                placeholder="Panel name"
                                v-model="form.panel_name"
                                name="panel_name"
                                id="panel_name"
                                class="form-control"
                            >
                            <error
                                name="panel_name"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="customer">Customer</label>
                            <customer-search
                                ref="customerSearch"
                                :customer="form.customer"
                                @change="customerChanged"
                                :customer-id="form.customer_id"
                            />
                            <error
                                name="customer_id"
                                :errors="errors"
                            />
                        </div>
                        <div
                            class="col-sm-12 col-md-6 form-group"
                            v-if="form.customer && form.customer.sites"
                        >
                            <label for="site">Site:</label>
                            <select
                                name="site"
                                v-model="form.site_id"
                                id="site"
                                class="form-control"
                                placeholder="Site"
                                required
                                v-if="form.customer.sites.length"
                                @change="siteChanged()"
                            >
                                <option value="">
                                    Select Site
                                </option>
                                <option
                                    v-for="site in form.customer.sites"
                                    :key="site.id"
                                    :value="site.id"
                                >
                                    #{{ site.site_no }} {{ site.name }}
                                </option>
                            </select>
                            <span
                                class="form-error"
                                v-if="!form.customer.sites.length"
                            >This customer has no sites</span>
                            <error
                                name="site_id"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="job_id">Job No.</label>
                            <select
                                v-if="jobs"
                                name="job_id"
                                id="job_id"
                                v-model="form.job_id"
                                class="form-control"
                                placeholder="Select a job"
                                :disabled="jobs.length < 1"
                            >
                                <option
                                    :value="null"
                                    disabled
                                >
                                    Select a job
                                </option>
                                <option
                                    v-for="job in jobs"
                                    :key="job.id"
                                    :value="job.id"
                                >
                                    {{ job.id }}: {{ job.name }}
                                </option>
                            </select>
                            <error
                                name="job_id"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="doc_no">Document No.</label>
                            <input
                                type="text"
                                id="doc_no"
                                name="doc_no"
                                v-model="form.doc_no"
                                placeholder="Document Number"
                                class="form-control"
                            >
                            <error
                                name="doc_no"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="service_report_no">Fire Alarm Service Report Number</label>
                            <input
                                type="text"
                                id="service_report_no"
                                name="service_report_no"
                                v-model="form.service_report_no"
                                placeholder="Service Report Number"
                                class="form-control"
                            >
                            <error
                                name="service_report_no"
                                :errors="errors"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Previous Visits</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <table class="table">
                                <tr>
                                    <td>
                                        <label for="is_second_visit">Is this the second visit?</label>
                                    </td>

                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="is_second_visit"
                                            id="is_second_visit"
                                            v-model="form.is_second_visit"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="is_second_visit"
                                            v-model="form.is_second_visit"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="is_second_visit"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr v-if="form.is_second_visit === 'Yes'">
                                    <td>
                                        <label for="previous_form_id">Select previous form:</label>
                                    </td>

                                    <td class="text-right">
                                        <select
                                            name="previous_form_id"
                                            id="previous_form_id"
                                            v-model="form.prev_form_id"
                                            @change="prevFormChanged"
                                        >
                                            <option
                                                :value="null"
                                                disabled
                                            >
                                                Select Form
                                            </option>
                                            <option
                                                :value="f.id"
                                                v-for="(f, index) in prev_forms"
                                                :key="index"
                                            >
                                                #{{ f.doc_no }} {{ formatDate(f.created_at) }}
                                            </option>
                                        </select>
                                        <error
                                            name="is_second_visit"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>General</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table">
                                <tr>
                                    <td>
                                        <label for="signed_in">Have You Signed In?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="signed_in"
                                            v-model="form.signed_in"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="signed_in"
                                            v-model="form.signed_in"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="signed_in"
                                            v-model="form.signed_in"
                                            value="N\A"
                                        > N/A</label>
                                        <error
                                            name="signed_in"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="require_rams">Does the customer require our RAMS?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="require_rams"
                                            v-model="form.require_rams"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="require_rams"
                                            v-model="form.require_rams"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="require_rams"
                                            v-model="form.require_rams"
                                            value="N/A"
                                        > N/A</label>
                                        <error
                                            name="signed_in"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="risk_assessment">Is there a fire risk assessment on site and has it been reviewed in the last 12 months?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="risk_assessment"
                                            v-model="form.risk_assessment"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="risk_assessment"
                                            v-model="form.risk_assessment"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="risk_assessment"
                                            v-model="form.risk_assessment"
                                            value="N/A"
                                        > N/A</label>
                                        <error
                                            name="risk_assessment"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="action_points">Have all relevant action points been resolved?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="action_points"
                                            v-model="form.action_points"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="action_points"
                                            v-model="form.action_points"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="actions_points"
                                            v-model="form.action_points"
                                            value="N/A"
                                        > N/A</label>
                                        <error
                                            name="action_points"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="asbestos_report">Have you checked and reviewed the asbestos report?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="asbestos_report"
                                            v-model="form.asbestos_report"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="asbestos_report"
                                            v-model="form.asbestos_report"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="asbestos_report"
                                            v-model="form.asbestos_report"
                                            value="N/A"
                                        > N/A</label>
                                        <error
                                            name="asbestos_report"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>System Details</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table">
                                <tr>
                                    <td>
                                        <label for="fire_alarm_type">Fire Alarm System Type</label>
                                    </td>
                                    <td class="text-right">
                                        <select
                                            name="fire_alarm_type"
                                            id="fire_alarm_type"
                                            v-model="form.fire_alarm_type"
                                            class="form-control"
                                        >
                                            <option disabled>
                                                Select
                                            </option>
                                            <option value="L1">
                                                L1
                                            </option>
                                            <option value="L2">
                                                L2
                                            </option>
                                            <option value="L3">
                                                L3
                                            </option>
                                            <option value="L4">
                                                L4
                                            </option>
                                            <option value="L5">
                                                L5
                                            </option>
                                            <option value="P1">
                                                P1
                                            </option>
                                            <option value="P2">
                                                P2
                                            </option>
                                            <option value="M">
                                                M
                                            </option>
                                            <option value="X">
                                                X
                                            </option>
                                        </select>
                                        <error
                                            name="fire_alarm_type"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="service_type">What service are you carrying out?</label>
                                    </td>
                                    <td class="text-right">
                                        <select
                                            name="service_type"
                                            id="service_type"
                                            v-model="form.service_type"
                                            class="form-control"
                                        >
                                            <option disabled>
                                                Select
                                            </option>
                                            <option>Full New Service</option>
                                            <option>6 Monthly Annual Service</option>
                                            <option>3 Monthly Annual Service</option>
                                            <option>Call Out / Schedule</option>
                                        </select>
                                        <error
                                            name="service_type"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="cie_located">Is the Control Indication Equipment (CIE) located at the main entrance in accordance to BS 5839?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="cie_located"
                                            v-model="form.cie_located"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="cie_located"
                                            v-model="form.cie_located"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="cie_located"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="cie_manufacturer">The Control Indication Equipment (CIE) Type / Manufacture</label>
                                    </td>
                                    <td class="text-right">
                                        <input
                                            type="text"
                                            v-model="form.cie_manufacturer"
                                            placeholder="Type here.."
                                            class="form-control"
                                        >
                                        <error
                                            name="cie_manufacturer"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="cie_protocol">The Control Indication Equipment (CIE) system protocol</label>
                                    </td>
                                    <td class="text-right">
                                        <select
                                            name="cie_protocol"
                                            id="cie_protocol"
                                            v-model="form.cie_protocol"
                                            class="form-control"
                                        >
                                            <option
                                                disabled
                                                :value="null"
                                            >
                                                Select
                                            </option>
                                            <option>Conventional</option>
                                            <option>Addressable</option>
                                            <option>Bi-Wire</option>
                                        </select>
                                        <error
                                            name="cie_protocol"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="device_system_protocol">Device system protocol</label>
                                    </td>
                                    <td class="text-right">
                                        <input
                                            type="text"
                                            v-model="form.device_system_protocol"
                                            placeholder="Type here.."
                                            class="form-control"
                                        >
                                        <error
                                            name="device_system_protocol"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="cie_max_zones">The Control Indication Equipment (CIE) Maximum Number of Zones</label>
                                    </td>
                                    <td class="text-right">
                                        <input
                                            type="number"
                                            step="1"
                                            min="0"
                                            max="200"
                                            v-model="form.cie_max_zones"
                                            placeholder="1"
                                            class="form-control"
                                        >
                                        <error
                                            name="cie_max_zones"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="panel_user_code">Fire Panel User Code</label>
                                    </td>
                                    <td class="text-right">
                                        <input
                                            type="text"
                                            v-model="form.panel_user_code"
                                            placeholder="Type here.."
                                            class="form-control"
                                        >
                                        <error
                                            name="panel_user_code"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="panel_engineer_code">Fire Panel Engineer Code</label>
                                    </td>
                                    <td class="text-right">
                                        <input
                                            type="text"
                                            v-model="form.panel_engineer_code"
                                            placeholder="Type here.."
                                            class="form-control"
                                        >
                                        <error
                                            name="panel_engineer_code"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="safe_isolation">Is there a safe means of isolation?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="safe_isolation"
                                            v-model="form.safe_isolation"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="safe_isolation"
                                            v-model="form.safe_isolation"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="safe_isolation"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>


                                <tr>
                                    <td>
                                        <label for="two_sounder_circuits">Are there a minimum of two sounder circuits present?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="two_sounder_circuits"
                                            v-model="form.two_sounder_circuits"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="two_sounder_circuits"
                                            v-model="form.two_sounder_circuits"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="two_sounder_circuits"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="short_circuit_tested">Have open/short circuit, head removal and end of line tests been carried out?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="short_circuit_tested"
                                            v-model="form.short_circuit_tested"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="short_circuit_tested"
                                            v-model="form.short_circuit_tested"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="short_circuit_tested"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="detector_clean">Are all detectors clean from visual contamination?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="detector_clean"
                                            v-model="form.detector_clean"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="detector_clean"
                                            v-model="form.detector_clean"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="detector_clean"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="analogue_values_in_line">Are analogue values in line with the manufacturers recommendations?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="analogue_values_in_line"
                                            v-model="form.analogue_values_in_line"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="analogue_values_in_line"
                                            v-model="form.analogue_values_in_line"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="analogue_values_in_line"
                                            v-model="form.analogue_values_in_line"
                                            value="N\A"
                                        > N/A</label>
                                        <error
                                            name="analogue_values_in_line"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="control_panel_buzzer">Does the fire control panel buzzer work correctly?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="control_panel_buzzer"
                                            v-model="form.control_panel_buzzer"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="control_panel_buzzer"
                                            v-model="form.control_panel_buzzer"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="control_panel_buzzer"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Signage</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table">
                                <tr>
                                    <td>
                                        <label for="signage_present">Are all fire action signs present and installed to BS 5499?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="signage_present"
                                            v-model="form.signage_present"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="signage_present"
                                            v-model="form.signage_present"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="signage_present"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="signs_emergency_lighting">Are all Non-photo luminescent signs covered by emergency lighting?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="signs_emergency_lighting"
                                            v-model="form.signs_emergency_lighting"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="signs_emergency_lighting"
                                            v-model="form.signs_emergency_lighting"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="signs_emergency_lighting"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="zone_plans">Are diagrammatic zone plans installed as per BS 5839?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="zone_plans"
                                            v-model="form.zone_plans"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="zone_plans"
                                            v-model="form.zone_plans"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="zone_plans"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Devices</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table">
                                <tr>
                                    <td>
                                        <label for="devices_located_correctly">Are all devices, that have been tested during this maintenance visit, located correctly?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="devices_located_correctly"
                                            v-model="form.devices_located_correctly"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="devices_located_correctly"
                                            v-model="form.devices_located_correctly"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="devices_located_correctly"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="detectors_appropriate">Are the detectors appropriate for the environment/risk?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="detectors_appropriate"
                                            v-model="form.detectors_appropriate"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="detectors_appropriate"
                                            v-model="form.detectors_appropriate"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="detectors_appropriate"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="devices_satisfy_system">Do the devices installed satisfy system category requirements?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="devices_satisfy_system"
                                            v-model="form.devices_satisfy_system"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="devices_satisfy_system"
                                            v-model="form.devices_satisfy_system"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="devices_satisfy_system"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="sounders_tested">Were you able to test the sounders on site?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="sounders_tested"
                                            v-model="form.sounders_tested"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="sounders_tested"
                                            v-model="form.sounders_tested"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="sounders_tested"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="sound_coverage">Is there sufficient sounder coverage throughout the premises? (dB test)</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="sound_coverage"
                                            v-model="form.sound_coverage"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="sound_coverage"
                                            v-model="form.sound_coverage"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="sound_coverage"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="similar_tone">Are all the sounders of a similar tone?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="similar_tone"
                                            v-model="form.similar_tone"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="similar_tone"
                                            v-model="form.similar_tone"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="similar_tone"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="door_closers">Are all door retainers/closers correctly fitted and operating correctly?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="door_closers"
                                            v-model="form.door_closers"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="door_closers"
                                            v-model="form.door_closers"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="door_closers"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Power Supplies</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table">
                                <tr>
                                    <td>
                                        <label for="cie_battery_qty">Quantity of Control Indication Equipment (CIE) Batteries</label>
                                    </td>
                                    <td class="text-right">
                                        <select
                                            name="cie_battery_qty"
                                            id="cie_battery_qty"
                                            class="form-control"
                                            v-model="form.cie_battery_qty"
                                        >
                                            <option disabled>
                                                Select
                                            </option>
                                            <option value="1">
                                                1
                                            </option>
                                            <option value="2">
                                                2
                                            </option>
                                            <option value="3">
                                                3
                                            </option>
                                            <option value="4">
                                                4
                                            </option>
                                        </select>
                                        <error
                                            name="cie_battery_qty"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>
                            </table>

                            <table class="table">
                                <tr v-if="form.cie_battery_qty > 0">
                                    <td>
                                        <label>Battery 1</label>
                                    </td>
                                    <td>
                                        <label>Size (AMP)</label>
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            step="0.001"
                                            min="0"
                                            class="form-control"
                                            v-model="form.battery_1_size"
                                            placeholder="2.1"
                                        >
                                    </td>
                                    <td>
                                        <label>Battery Volts</label>
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            step="0.001"
                                            min="0"
                                            class="form-control"
                                            v-model="form.battery_1_volts"
                                            placeholder="12"
                                        >
                                    </td>
                                    <td>
                                        <label>Battery Amps</label>
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            step="0.001"
                                            min="0"
                                            class="form-control"
                                            v-model="form.battery_1_amps"
                                            placeholder="2"
                                        >
                                    </td>
                                </tr>
                                <tr v-if="form.cie_battery_qty > 1">
                                    <td>
                                        <label>Battery 2</label>
                                    </td>
                                    <td>
                                        <label>Size (AMP)</label>
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            step="0.001"
                                            min="0"
                                            class="form-control"
                                            v-model="form.battery_2_size"
                                            placeholder="2.1"
                                        >
                                    </td>
                                    <td>
                                        <label>Battery Volts</label>
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            step="0.001"
                                            min="0"
                                            class="form-control"
                                            v-model="form.battery_2_volts"
                                            placeholder="12"
                                        >
                                    </td>
                                    <td>
                                        <label>Battery Amps</label>
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            step="0.001"
                                            min="0"
                                            class="form-control"
                                            v-model="form.battery_2_amps"
                                            placeholder="2"
                                        >
                                    </td>
                                </tr>
                                <tr v-if="form.cie_battery_qty > 2">
                                    <td>
                                        <label>Battery 3</label>
                                    </td>
                                    <td>
                                        <label>Size (AMP)</label>
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            step="0.001"
                                            min="0"
                                            class="form-control"
                                            v-model="form.battery_3_size"
                                            placeholder="2.1"
                                        >
                                    </td>
                                    <td>
                                        <label>Battery Volts</label>
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            step="0.001"
                                            min="0"
                                            class="form-control"
                                            v-model="form.battery_3_volts"
                                            placeholder="12"
                                        >
                                    </td>
                                    <td>
                                        <label>Battery Amps</label>
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            step="0.001"
                                            min="0"
                                            class="form-control"
                                            v-model="form.battery_3_amps"
                                            placeholder="2"
                                        >
                                    </td>
                                </tr>
                                <tr v-if="form.cie_battery_qty > 3">
                                    <td>
                                        <label>Battery 4</label>
                                    </td>
                                    <td>
                                        <label>Size (AMP)</label>
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            step="0.001"
                                            min="0"
                                            class="form-control"
                                            v-model="form.battery_4_size"
                                            placeholder="2.1"
                                        >
                                    </td>
                                    <td>
                                        <label>Battery Volts</label>
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            step="0.001"
                                            min="0"
                                            class="form-control"
                                            v-model="form.battery_4_volts"
                                            placeholder="12"
                                        >
                                    </td>
                                    <td>
                                        <label>Battery Amps</label>
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            step="0.001"
                                            min="0"
                                            class="form-control"
                                            v-model="form.battery_4_amps"
                                            placeholder="2"
                                        >
                                    </td>
                                </tr>
                            </table>

                            <table class="table">
                                <tr>
                                    <td>
                                        <label for="charger_voltage">Charger voltage (V)</label>
                                    </td>
                                    <td class="text-right">
                                        <input
                                            type="number"
                                            step="0.001"
                                            v-model="form.charger_voltage"
                                            placeholder="Type here.."
                                            class="form-control"
                                        >
                                        <error
                                            name="charger_voltage"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="quiscent_load">Quiescent Load (A)</label>
                                    </td>
                                    <td class="text-right">
                                        <input
                                            type="number"
                                            step="0.001"
                                            v-model="form.quiscent_load"
                                            placeholder="Type here.."
                                            class="form-control"
                                        >
                                        <error
                                            name="quiscent_load"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="alarm_load">Alarm Load (A)</label>
                                    </td>
                                    <td class="text-right">
                                        <input
                                            type="number"
                                            step="0.001"
                                            v-model="form.alarm_load"
                                            placeholder="Type here.."
                                            class="form-control"
                                        >
                                        <error
                                            name="alarm_load"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="battery_calculation">Battery Calculation [(I1xT1)+I2]x1.25</label>
                                    </td>
                                    <td
                                        class="text-right"
                                        style="display: flex;"
                                    >
                                        <input
                                            type="number"
                                            step="0.001"
                                            v-model="form.battery_calculation"
                                            placeholder="Type here.."
                                            class="form-control"
                                        >
                                        <button
                                            class="btn btn-info"
                                            @click.prevent="calcBattery"
                                        >
                                            Calculate
                                        </button>
                                        <error
                                            name="battery_calculation"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="psu_batteries_tested">Have external PSU batteries been tested</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="psu_batteries_tested"
                                            v-model="form.psu_batteries_tested"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="psu_batteries_tested"
                                            v-model="form.psu_batteries_tested"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="psu_batteries_tested"
                                            v-model="form.psu_batteries_tested"
                                            value="N/A"
                                        > N/A</label>
                                        <error
                                            name="psu_batteries_tested"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="batteries_sufficient">Do the batteries installed have sufficient capacity for the system ?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="batteries_sufficient"
                                            v-model="form.batteries_sufficient"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="batteries_sufficient"
                                            v-model="form.batteries_sufficient"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="batteries_sufficient"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>System Test</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <table class="table devices-table">
                                <thead>
                                    <tr>
                                        <th
                                            class="th td td-zone"
                                            @click="sortDevices('zone')"
                                            :class="sortClass('zone')"
                                        >
                                            Zone
                                        </th>
                                        <th
                                            class="th td td-det"
                                            @click="sortDevices('detector_no')"
                                            :class="sortClass('detector_no')"
                                        >
                                            Det. No
                                        </th>
                                        <th
                                            class="th td td-type"
                                            @click="sortDevices('type')"
                                            :class="sortClass('type')"
                                        >
                                            Type
                                        </th>
                                        <th
                                            class="th td td-location"
                                            @click="sortDevices('location')"
                                            :class="sortClass('location')"
                                        >
                                            Location
                                        </th>
                                        <th
                                            class="th td td-year"
                                            @click="sortDevices('year')"
                                            :class="sortClass('year')"
                                        >
                                            Year
                                        </th>
                                        <th
                                            class="th td td-prev-tested"
                                            v-if="form.is_second_visit === 'Yes'"
                                        >
                                            Prev. Tested
                                        </th>
                                        <th
                                            class="th td td-tested"
                                            @click="sortDevices('tested')"
                                            :class="sortClass('tested')"
                                        >
                                            Tested
                                        </th>
                                        <th
                                            class="th td td-pass-fail"
                                            @click="sortDevices('test_result')"
                                            :class="sortClass('test_result')"
                                        >
                                            Passed/Failed
                                        </th>
                                        <th><!-- options --></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(device, i) in form.devices"
                                        :key="i"
                                    >
                                        <td class="td td-zone">
                                            <input
                                                type="text"
                                                v-model="device.zone"
                                                placeholder="Zone"
                                                class="form-control"
                                            >
                                        </td>
                                        <td class="td td-det">
                                            <input
                                                type="text"
                                                v-model="device.detector_no"
                                                placeholder="Det. No."
                                                class="form-control"
                                            >
                                        </td>
                                        <td class="td td-type">
                                            <input
                                                type="text"
                                                v-model="device.type"
                                                placeholder="Type"
                                                class="form-control"
                                            >
                                        </td>
                                        <td class="td td-location">
                                            <input
                                                type="text"
                                                v-model="device.location"
                                                placeholder="Location"
                                                class="form-control"
                                            >
                                        </td>
                                        <td class="td td-year">
                                            <input
                                                type="text"
                                                v-model="device.year"
                                                placeholder="Year"
                                                class="form-control"
                                            >
                                        </td>
                                        <td
                                            class="td td-prev-tested"
                                            v-if="form.is_second_visit === 'Yes'"
                                        >
                                            <span v-if="device.prev_tested">Y</span>
                                            <span v-if="!device.prev_tested">N</span>
                                        </td>
                                        <td class="td td-tested">
                                            <input
                                                type="checkbox"
                                                v-model="device.tested"
                                                value="1"
                                                class="form-control"
                                            >
                                        </td>
                                        <td class="td td-pass-fail">
                                            <label class="button-radio">
                                                <input
                                                    type="radio"
                                                    :name="'test_result[' + i + ']'"
                                                    v-model="device.test_result"
                                                    value="passed"
                                                    @click="toggleDeviceTestResult(i, 'passed')"
                                                >
                                                <span class="button-radio-text">Passed</span>
                                            </label>
                                            <label class="button-radio">
                                                <input
                                                    type="radio"
                                                    :name="'test_result[' + i + ']'"
                                                    v-model="device.test_result"
                                                    value="failed"
                                                    @click="toggleDeviceTestResult(i, 'failed')"
                                                >
                                                <span class="button-radio-text button-radio-text--failed">Failed</span>
                                            </label>
                                        </td>
                                        <td class="td td-buttons">
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-outline-danger"
                                                @click="removeDevice(i)"
                                            >
                                                <i class="fa fa-times" />
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td
                                            class="text-right"
                                            colspan="8"
                                        >
                                            <button
                                                class="btn btn-info"
                                                type="button"
                                                @click="addSiteDevices"
                                                :disabled="!form.site_id || site_devices.length === 0"
                                            >
                                                <i class="fa fa-download" />
                                                Add devices from site
                                            </button>
                                            <button
                                                class="btn btn-info"
                                                type="button"
                                                @click="parsePrevForm"
                                                :disabled="!prev_form"
                                            >
                                                Check Prev. Form
                                            </button>

                                            <span
                                                v-if="form.devices"
                                                class="devices-count"
                                            >Total Devices:  {{ form.devices.length }}</span>
                                            <button
                                                class="btn btn-primary"
                                                type="button"
                                                @click="addDevice"
                                            >
                                                <i class="fa fa-plus" /> Add Device
                                            </button>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Monitoring and Panel Downloads</h3>
                        </div>
                    </div>

                    <table class="table">
                        <tr>
                            <td>
                                <label for="percentage_checked">Percentage of the system checked</label>
                            </td>
                            <td class="text-right">
                                <div class="input-group">
                                    <input
                                        type="text"
                                        v-model="percentage_checked"
                                        placeholder="100"
                                        class="form-control text-right"
                                        disabled
                                    >
                                    <div class="input-group-append">
                                        <span class="input-group-text">%</span>
                                    </div>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <label for="signals_tested">Have signals been tested through to the monitoring station?</label>
                            </td>
                            <td class="text-right">
                                <label class="form-check-label"><input
                                    type="radio"
                                    name="signals_tested"
                                    v-model="form.signals_tested"
                                    value="Yes"
                                > Yes</label>
                                <label class="form-check-label"><input
                                    type="radio"
                                    name="signals_tested"
                                    v-model="form.signals_tested"
                                    value="No"
                                > No</label>
                                <label class="form-check-label"><input
                                    type="radio"
                                    name="signals_tested"
                                    v-model="form.signals_tested"
                                    value="N/A"
                                > N/A</label>
                                <error
                                    name="signals_tested"
                                    :errors="errors"
                                />
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <label for="panel_download_complete">Has a panel data and configuration download been completed?</label>
                            </td>
                            <td class="text-right">
                                <label class="form-check-label"><input
                                    type="radio"
                                    name="panel_download_complete"
                                    v-model="form.panel_download_complete"
                                    value="Yes"
                                > Yes</label>
                                <label class="form-check-label"><input
                                    type="radio"
                                    name="panel_download_complete"
                                    v-model="form.panel_download_complete"
                                    value="No"
                                > No</label>
                                <label class="form-check-label"><input
                                    type="radio"
                                    name="panel_download_complete"
                                    v-model="form.panel_download_complete"
                                    value="N\A"
                                > N/A</label>
                                <error
                                    name="panel_download_complete"
                                    :errors="errors"
                                />
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <label for="monitored_for_fire">Is the site monitored for fire?</label>
                            </td>
                            <td class="text-right">
                                <label class="form-check-label"><input
                                    type="radio"
                                    name="monitored_for_fire"
                                    v-model="form.monitored_for_fire"
                                    value="Yes"
                                > Yes</label>
                                <label class="form-check-label"><input
                                    type="radio"
                                    name="monitored_for_fire"
                                    v-model="form.monitored_for_fire"
                                    value="No"
                                > No</label>
                                <label class="form-check-label"><input
                                    type="radio"
                                    name="monitored_for_fire"
                                    v-model="form.monitored_for_fire"
                                    value="N\A"
                                > N/A</label>
                                <error
                                    name="monitored_for_fire"
                                    :errors="errors"
                                />
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <label for="monitored_by_company">Is the site monitored by {{ sysSetting('company_name') }}?</label>
                            </td>
                            <td class="text-right">
                                <label class="form-check-label"><input
                                    type="radio"
                                    name="monitored_by_company"
                                    v-model="form.monitored_by_company"
                                    value="Yes"
                                > Yes</label>
                                <label class="form-check-label"><input
                                    type="radio"
                                    name="monitored_by_company"
                                    v-model="form.monitored_by_company"
                                    value="No"
                                > No</label>
                                <label class="form-check-label"><input
                                    type="radio"
                                    name="monitored_by_company"
                                    v-model="form.monitored_by_company"
                                    value="N\A"
                                > N/A</label>
                                <error
                                    name="monitored_by_company"
                                    :errors="errors"
                                />
                            </td>
                        </tr>

                        <tr v-if="form.monitored_by_company === 'Yes'">
                            <td>
                                <label for="chip_number">Enter Chip Number:</label>
                            </td>
                            <td class="text-right">
                                <input
                                    type="text"
                                    placeholder="Chip Number"
                                    v-model="form.chip_number"
                                    class="form-control"
                                >
                                <error
                                    name="chip_number"
                                    :errors="errors"
                                />
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Observations and Recommendations</h3>
                            <textarea
                                name="recommendations"
                                id="recommendations"
                                cols="30"
                                rows="10"
                                class="form-control"
                                placeholder="Type observations and recommendations here..."
                                v-model="form.recommendations"
                            />
                            <error
                                name="recommendations"
                                :errors="errors"
                            />
                            <button
                                class="btn btn-info"
                                type="button"
                                @click.prevent="fillRecommendations()"
                            >
                                Fill Recommendations
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Logs and Final Checks</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <table class="table">
                                <tr>
                                    <td>
                                        <label for="fire_log_book">Has the fire log book been completed?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="fire_log_book"
                                            v-model="form.fire_log_book"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="fire_log_book"
                                            v-model="form.fire_log_book"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="fire_log_book"
                                            v-model="form.fire_log_book"
                                            value="N/A"
                                        > N/A</label>
                                        <error
                                            name="fire_log_book"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="fully_operational">System left fully operational?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="fully_operational"
                                            v-model="form.fully_operational"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="fully_operational"
                                            v-model="form.fully_operational"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="fully_operational"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="fault_free">System left fault free?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="fault_free"
                                            v-model="form.fault_free"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="fault_free"
                                            v-model="form.fault_free"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="fault_free"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="recorded_and_reported">Have all recommendations, outstanding issues and Non-complances been recorded and reported to the responsible person?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="recorded_and_reported"
                                            v-model="form.recorded_and_reported"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="recorded_and_reported"
                                            v-model="form.recorded_and_reported"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="recorded_and_reported"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Notes</h3>
                            <textarea
                                name="Notes"
                                id="Notes"
                                cols="30"
                                rows="10"
                                class="form-control"
                                v-model="form.notes"
                                placeholder="Type Notes here..."
                            />
                            <error
                                name="notes"
                                :errors="errors"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Signoff</h3>
                            <p> I declare that I am the competent person (CP) in the fire alarm system maintenance. All equipment returned to normal. Serviced according to BS 5839-1:2002</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-8">
                            <label class="top">Engineer Signature:</label>
                            <br>
                            <user-select
                                v-model="form.engineer_id"
                                :office="false"
                                :admins="false"
                            />
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="engineer_sign_date"
                                class="top"
                            >Date</label>
                            <br>
                            <date-picker
                                v-model="form.engineer_sign_date"
                                id="engineer_sign_date"
                                :options="{format: 'L'}"
                                required
                            />
                            <error
                                :errors="errors"
                                name="engineer_sign_date"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <p>Accepted, For and behalf of the user, by Responsible person (RP). I understand that the system is operating as designed I understand that if any items, were shown to be defective, the fire alarm system may not comply with BS 5266</p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-4">
                            <label class="top">Customer Signature:</label>
                            <br>
                            <signature
                                v-if="!form.customer_signature"
                                ref="customerSignature"
                            />
                            <img
                                v-if="form.customer_signature"
                                :src="form.customer_signature"
                                alt="Customer signature"
                            >
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="customer_sign_name"
                                class="top"
                            >Customer Name</label>
                            <br>
                            <input
                                type="text"
                                v-model="form.customer_sign_name"
                                id="customer_sign_name"
                                name="customer_sign_name"
                                placeholder="Customer Name"
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="customer_sign_name"
                            />
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="customer_sign_date"
                                class="top"
                            >Date</label>
                            <br>
                            <date-picker
                                v-model="form.customer_sign_date"
                                id="customer_sign_date"
                                :options="{format: 'L'}"
                                required
                            />
                            <error
                                :errors="errors"
                                name="customer_sign_date"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row form-group">
                        <div class="col-12">
                            <button
                                class="btn btn-success"
                                type="submit"
                                :disabled="isSaving || isLoading"
                            >
                                Save
                            </button>

                            <button
                                class="btn btn-outline-danger"
                                type="button"
                                @click="deleteForm()"
                                :disabled="isSaving || isLoading"
                                v-if="form.id && canDelete"
                            >
                                <i class="fa fa-times" /> Delete
                            </button>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/stream'"
                                target="_blank"
                            >
                                <i class="fa fa-print" /> Preview/Print
                            </a>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/download'"
                                target="_blank"
                                :download="form.doc_no + '.pdf'"
                            >
                                <i class="fa fa-file" /> Download PDF
                            </a>

                            <router-link
                                class="btn btn-info"
                                v-if="form.id"
                                :to="{name: 'office.emails.new', params: {customer_id: form.customer_id}, query: {form_id: form.id}}"
                            >
                                <i class="fa fa-envelope" /> Send to Customer
                            </router-link>

                            <router-link
                                class="btn btn-info"
                                v-if="form.id"
                                :to="{name: 'office.forms.new', query: {alarm_form: form.id, type: 'fire_alarm_certificate'}}"
                            >
                                <i class="fa fa-copy" /> Create Certificate
                            </router-link>

                            <router-link
                                :to="{name: 'engineer.jobs.show', params: {id: form.job_id}}"
                                class="btn btn-info"
                                v-if="$route.name === 'engineer.forms.edit' && form.job_id"
                            >
                                <i class="fa fa-chevron-left" /> Back to Job
                            </router-link>

                            <router-link
                                :to="{name: 'office.jobs.show', params: {id: form.job_id}}"
                                class="btn btn-info"
                                v-if="$route.name === 'office.forms.edit' && form.job_id"
                            >
                                <i class="fa fa-briefcase" /> View Job
                            </router-link>

                            <customer-site-footer-links
                                :customer-id="form.customer_id"
                                :site-id="form.site_id"
                            />

                            <activity-log
                                v-if="form.id"
                                :id="form.id"
                                model="Form"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import datePicker from "../DateTimePickerComponent.vue";
import CustomerSearchComponent from "../CustomerSearch.vue";
import Service from "../../services/FormService";
import * as moment from "moment";
import SignatureComponent from "../SignatureComponent.vue";
import AuthService from "../../services/AuthService";
import JobService from "../../services/JobService";
import FormService from "../../services/FormService";
import * as FireAlarmForm from "../../include/FireAlarmForm";
import SiteService from "../../services/SitesService";
import UsesErrors from "../../mixins/UsesErrors";
import UsesInfoMessage from "../../mixins/UsesInfoMessage";
import Sortables from "../../mixins/Sortables";
import SettingsMixin from "../../mixins/SystemSettings";
import UsesFormRouteQuery from "../../mixins/UsesFormRouteQuery";

export default {
    components: {
        "customer-search": CustomerSearchComponent,
        "date-picker": datePicker,
        signature: SignatureComponent
    },
    mixins: [
        UsesErrors,
        UsesInfoMessage,
        Sortables,
        SettingsMixin,
        UsesFormRouteQuery,
    ],
    props: {
        formId: {
            default: () => null
        },
    },
    data: function () {
        return {
            changed: false,
            sites: [],
            customerSignature: null,
            jobs: [],
            form: {
                type: "fire_alarm_test",
                customer: {
                    company_name: "",
                },
                panel_name: 'Panel 1',
                job_id: null,
                site_id: null,
                doc_no: '',
                service_report_no: '',
                signed_in: null,
                required_rams: null,
                risk_assessment: null,
                action_points: null,
                asbestos_report: null,
                fire_alarm_type: null,
                service_type: null,
                cie_located: null,
                cie_manufacturer: null,
                cie_protocol: null,
                cie_max_zones: 0,
                panel_user_code: '',
                panel_engineer_code: '',
                safe_isolation: null,
                two_sounder_circuits: null,
                detector_clean: null,
                analogue_values_in_line: null,
                control_panel_buzzer: null,
                signage_present: null,
                signs_emergency_lighting: null,
                zone_plans: null,
                devices_located_correctly: null,
                detectors_appropriate: null,
                devices_satisfy_system: null,
                sound_coverage: null,
                similar_tone: null,
                door_closers: null,
                cie_battery_qty: 1,
                battery_1_size: null,
                battery_1_volts: null,
                battery_1_amps: null,
                battery_2_size: null,
                battery_2_volts: null,
                battery_2_amps: null,
                devices: [],
                recommendations: '',
                customer_sign_date: moment(),
                engineer_sign_date: moment(),
                is_second_visit: 'No',
                prev_form_id: null,

            },
            site_devices: [],
            token: null,
            mcp_types: FireAlarmForm.mcp_types,
            prev_forms: [],
            prev_form: null,
        };
    },

    computed: {
        percentage_checked: function () {
            if (!this.form.devices) {
                return 100;
            }
            let total = this.form.devices.length;
            if (total < 1) {
                return 100;
            }
            let checked = this.form.devices.filter(device => device.tested == 1).length;
            return ((checked / total) * 100).toFixed(0);
        },
        canDelete: function () {
            return AuthService.user.admin_access || AuthService.user.office_access;
        },
    },

    mounted: function () {
        this.populateFormFromRouteQuery();

        if (this.$route.params.id) {
            const id = this.$route.params.id;
            this.loadForm(id);
        } else {
            FormService.nextNo().then(res => {
                this.form.doc_no = res.data;
            });
        }

        if (!this.form.engineer_sign_date) {
            this.form.engineer_sign_date = moment();
        }
        if (!this.form.customer_sign_date) {
            this.form.customer_sign_date = moment();
        }
    },
    methods: {
        loadForm: function (id) {
            this.setLoading();
            FormService.get(id).then(res => {
                this.form = res.data;
                if (!this.form.devices) {
                    this.form.devices = [];
                }
                if (!this.form.customer) {
                    this.form.customer = {
                        company_name: '',
                    };
                }
                if (res.data.engineer_sign_date) {
                    this.form.engineer_sign_date = moment(res.data.engineer_sign_date);
                } else {
                    this.form.engineer_sign_date = moment();
                }
                if (res.data.customer_sign_date) {
                    this.form.customer_sign_date = moment(res.data.customer_sign_date);
                } else {
                    this.form.engineer_sign_date = moment();
                }
                if (!res.data.panel_name) {
                    this.form.panel_name = 'Panel 1';
                }
                this.getJobs();
                this.siteChanged();
                this.prevFormChanged();
            }).catch(err => {
                this.setErrorMessage('Could not load form');
            }).then(() => {
                this.clearLoading()
            });
        },
        customerChanged: function (customer) {
            this.form.customer = customer ? customer : {};
            if (this.form.customer) {
                this.form.customer_id = this.form.customer.id;
            } else {
                this.form.customer_id = null;
            }
            if (customer && customer.sites) {
                if (!customer.sites.map(site => site.id).includes(this.form.site_id)) {
                    this.form.site_id = '';
                    this.siteChanged();
                }
            } else {
                this.form.site_id = '';
                this.siteChanged();
            }
            this.getJobs();
        },
        onJobLoadedFromRoute() {
            this.siteChanged();
            this.getJobs();
        },

        getJobs: function () {
            if (!this.form.customer_id) {
                this.jobs = [];
                this.form.job_id = null;
                return;
            }
            JobService.search({'filter[customer_id]': this.form.customer_id}).then(res => {
                this.jobs = res.data.data || [];
            }, err => {
                this.setErrorMessage('Could not load customer jobs');
                this.jobs = [];
            });
        },
        saveForm: function () {
            this.setSaving();
            if (this.$refs.customerSignature && !this.$refs.customerSignature.isEmpty()) {
                this.form.customer_signature = this.$refs.customerSignature.toPng();
            }
            this.form.percentage_checked = this.percentage_checked;
            this.form.materials = this.materials;

            let data = {...this.form};
            delete data['customer'];
            delete data['site'];
            delete data['job'];
            delete data['data'];

            if (this.form.id) {
                Service.update(data).then(
                    res => {
                        this.clearSaving();
                        this.setInfoMessage("Form saved successfully");
                        this.$emit('formSaved', res.data);
                    }
                ).catch(err => {
                    this.clearSaving();
                    this.captureRequestErrors(err);
                });
            } else {
                Service.create(data).then(
                    res => {
                        this.setInfoMessage("Form saved successfully");
                        this.clearSaving();
                        if (this.$route.path.includes('engineer/')) {
                            this.$router.push({
                                name: "engineer.forms.edit",
                                params: {
                                    id: res.data.id
                                }
                            });
                        } else {
                            this.$router.push({
                                name: 'office.forms.edit',
                                params: {
                                    id: res.data.id
                                }
                            });
                        }
                    }).catch(err => {
                    this.clearSaving();
                    this.captureRequestErrors(err);
                });
            }
        },
        deleteForm: function () {
            if (confirm("Are you sure you want to delete this form?")) {
                Service.delete(this.form).then(
                    xhr => {
                        this.setInfoMessage("Form successfully deleted");
                        this.$router.push({name: 'office.forms.search'});
                    },
                    error => {
                        this.setErrorMessage("Could not delete this form");
                    }
                )
            }
        },

        removeDevice: function (index) {
            const confirm = window.confirm('Are you sure you want to delete this device?');
            if(!confirm) {
                return;
            }
            this.form.devices.splice(index, 1);
            this.$forceUpdate();
        },

        addDevice: function () {
            this.form.devices.push({});
            this.parsePrevForm();
            this.$forceUpdate();
        },

        forceUpdate: function () {
            this.$forceUpdate();
        },

        fillRecommendations: function () {
            let r = [];
            const f = this.form;

            if (f.recommendations) {
                const confirm = window.confirm('This will overwrite current recommendations, is that OK?');
                if (!confirm) {
                    return;
                }
            }

            if (f.risk_assessment === 'No') {
                r.push('No Fire Risk Assessment on site or review over 12months ago.');
            }

            if (f.cie_located === 'No') {
                r.push('Control Indication Equipment (CIE) to be located at a main entrance in accordance to BS 5839.')
            }

            if (f.safe_isolation === 'No') {
                r.push('A safe means of isolation to be installed.')
            }

            if (f.two_sounder_circuits === 'No') {
                r.push('Extra sounder circuit to be installed.')
            }

            if (f.detector_clean === 'No') {
                r.push('Replace all detectors with visual contamination.')
            }

            if (f.analogue_values_in_line === 'No') {
                r.push('Replace Faulty Detectors that are outside analogue values as manufacturers recommendations.')
            }

            if (f.control_panel_buzzer === 'No') {
                r.push('Repair / Replace fire control panel buzzer.')
            }

            if (f.signage_present === 'No') {
                r.push('Install fire action signs as per BS 5499.')
            }

            if (f.signs_emergency_lighting === 'No') {
                r.push('Non-photo luminescent signs to be change to photo luminescent or install emergency lighting near.')
            }

            if (f.zone_plans === 'No') {
                r.push('Diagrammatic zone plans to be installed as per BS 5839.')
            }

            if (f.devices_located_correctly === 'No') {
                r.push('Relocate all devices to correct location.')
            }

            if (f.detectors_appropriate === 'No') {
                r.push('Change detectors to ensure correct & appropriate for the environment/risk.')
            }

            if (f.sound_coverage === 'No') {
                r.push('Extra sounders to be installed throughout / parts of the premises to increase dB test reading.')
            }

            if (f.similar_tone === 'No') {
                r.push('Sounders to be adjusted or changed to a similar tone across the site.')
            }

            if (f.door_closers === 'No') {
                r.push('Door retainers & closers need corrective action to enable them to operate correctly.')
            }

            if (f.batteries_sufficient === 'No') {
                r.push('Batteries installed do not meet sufficient capacity for the system?')
            }

            if (f.fully_operational === 'No') {
                r.push('The Fire System is not fully operational and may have a fault(s).')
            }

            this.form.recommendations = r.join('\n\n');
            this.$forceUpdate();
        },

        siteChanged: function () {
            if (typeof this.form.devices === "undefined") {
                this.form.devices = [];
            }

            this.loadSiteDevices();
            this.loadSiteFormFields();
            this.loadPrevForms();

            if (this.form.devices.length === 0) {
                this.addSiteDevices()
            }
        },

        loadPreviousForm: function () {
            if (this.form.site_id && this.form.type) {
                FormService.loadPrevious(this.form.type, this.form.site_id, this.form.id).then(
                    res => {
                        if (this.form.devices.length < 1 && res.data.devices) {
                            this.form.devices = res.data.devices.map((val) => {
                                val.tested = false;
                                return val;
                            });
                            this.$forceUpdate();
                        }
                    }
                );
            }
        },

        loadSiteDevices: function () {
            if (typeof this.form.site_id === 'undefined' || !this.form.site_id) {
                this.site_devices = [];
                return;
            }

            SiteService.get(this.form.site_id).then(res => {
                this.site_devices = res.data.devices;
            });
        },

        loadSiteFormFields: function () {
            if (typeof this.form.site_id === 'undefined' || !this.form.site_id) {
                this.site_devices = [];
                return;
            }

            SiteService.get(this.form.site_id).then(res => {
                if (res.data.form_fields) {
                    res.data.form_fields.forEach(field => {
                        if (!this.form[field.name]) {
                            this.form[field.name] = field.value;
                        }
                    });
                }

                if (res.data.fire_alarm_fields) {
                    this.form = {...res.data.fire_alarm_fields, ...this.form};
                }
            });
        },

        addSiteDevices: function () {
            if (this.form.devices.length > 0) {
                var confirm = window.confirm('This will override devices added to this form, continue?');
                if (!confirm) {
                    return;
                }

                this.form.devices = this.site_devices;
            } else {
                this.form.devices = this.site_devices;
            }

            this.parsePrevForm()

            this.$forceUpdate();
        },

        loadPrevForms: function () {
            if (!this.form.site_id) {
                this.prev_forms = null;
                return;
            }
            FormService.search({
                type: 'fire_alarm_test',
                site_id: this.form.site_id
            }).then(res => {
                this.prev_forms = res.data.data;
                this.prevFormChanged();
            }).catch(err => {
                this.setErrorMessage('Failed to load previous forms');
            });
        },

        formatDate: function (date) {
            if (!date) {
                return '';
            }

            return window.moment(date).format('DD/MM/YYYY');
        },

        prevFormChanged: function () {
            if (!this.form.prev_form_id || !this.prev_forms.length) {
                this.prev_form = {};
                return;
            }

            this.prev_form = this.prev_forms.find(form => form.id === this.form.prev_form_id);
            this.parsePrevForm();
        },

        parsePrevForm: function () {
            if (!this.prev_form) {
                return;
            }
            if (this.prev_form === null || typeof this.prev_form.data === 'undefined' || typeof this.prev_form.data.devices === 'undefined') {
                return;
            }

            let prev_devices = this.prev_form.data.devices;

            this.form.devices = this.form.devices.map(device => {
                // Find a previous device that matches
                const prev_device = prev_devices.find(pd => {
                    return device.zone == pd.zone &&
                        device.detector_no == pd.detector_no &&
                        device.location == pd.location &&
                        device.type == pd.type &&
                        device.year == pd.year;
                });

                if (!prev_device) {
                    device.prev_tested = false;
                    return device;
                }

                device.prev_tested = prev_device.tested;
                return device;
            });
            this.$forceUpdate();
        },

        toggleDeviceTestResult(i, result) {
            var val = this.form.devices[i].test_result;
            if (val === result) {
                this.form.devices[i].test_result = null;
                this.$forceUpdate();
            }
        },

        calcBattery() {
            const f = this.form;
            let q = parseFloat(f.quiscent_load);
            let a = parseFloat(f.alarm_load);
            let result = ((q * 24) + a) * 1.25;
            this.form.battery_calculation = result.toFixed(3);
            this.$forceUpdate();
        },

        sortDevices(key) {
            this.form.devices = this.sortItems(key, this.form.devices);
            this.$forceUpdate();
        },

            
    }
}
;
</script>

<style lang="scss">
    .devices-table {
        .th {
            vertical-align: bottom;
        }

        .td {
            padding: 5px 2px;

            &-zone {
                width: 4.2rem;
            }

            &-det {
                width: 5rem;
            }

            &-type {
                width: 4rem;
            }

            &-year {
                width: 5rem;
            }

            &-prev-tested {
                width: 3rem;
                text-align: center;
                vertical-align: middle;
            }

            &-tested {
                width: 2rem;
                vertical-align: middle;
            }

            &-buttons {
                width: 2rem;
            }

            &-pass-fail {
                width: 10rem;
                text-align: center;
            }
        }

        .button-radio {
            display: inline-block;
            margin: 0 1px;

            input {
                display: none
            }

            &-text {
                display: block;
                padding: 5px;
                background: #eeeeee;
                border-radius: 3px;
                text-align: center;
                width: auto;
                cursor: pointer;

                &:hover {
                    background: #a8a8a8
                }
            }

            input[type="radio"]:checked + .button-radio-text {
                background: #17a2b8;
                color: #ffffff;
            }

            input[type="radio"]:checked + .button-radio-text--failed {
                background: #b84f37;
                color: #ffffff;
            }
        }
    }

    .devices-count {
        margin-right: 1em;
        text-decoration: underline;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/FireAlarmTestFormComponent.vue